module.exports = __webpack_public_path__ + "static/media/bird.10767f92.png";